import React from "react";
import classNames from "classnames/bind";
import s from "./ExpertiseComponent.module.scss";
import { Button } from "@material-ui/core";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import Rating from "@material-ui/lab/Rating";

const ExpertiseComponent = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const data = props.data;

  const getSkillsView = (viewType) => {
    switch (viewType) {
      case "simple":
        return data.map((x, index) => (
          <Button
            key={index}
            className={cx(classes.button, classes.skillButton)}
            variant="contained"
            size="small"
            color="primary"
          >
            {x.name}
          </Button>
        ));
      case "rating":
        return data.map((x, index) => (
          <section key={index} className={s.skillRow}>
            <Button
              className={classes.skillButton}
              key={index}
              variant="contained"
              size="small"
              color="primary"
            >
              {x.name}
            </Button>
            <Rating
              readOnly
              className={classes.rating}
              name="rating-comp"
              value={+x.value}
              defaultValue={3.5}
              precision={0.5}
            />
          </section>
        ));
      case "progress":
        return data.map((x, index) => (
          <section key={index} className={s.skillRow}>
            <Button
              key={index}
              className={classes.skillButton}
              variant="contained"
              size="small"
              color="primary"
            >
              {x.name}
            </Button>
            <div className={cx(s.outerProgress, classes.outerProgress)}>
              <div
                className={cx(s.innerProgress, classes.primaryThemeColorBg)}
                style={{
                  width: `${(x.value / 5) * 100}%`,
                }}
              ></div>
            </div>
          </section>
        ));
      default:
        return data.map((x, index) => (
          <Button
            key={index}
            className={cx(classes.button, classes.skillButton)}
            variant="contained"
            size="small"
            color="primary"
          >
            {x.name}
          </Button>
        ));
    }
  };

  return (
    <section className={cx(s.container, classes.secondaryTextColor)}>
      {getSkillsView(props.type || "rating")}
    </section>
  );
};

export default ExpertiseComponent;

const compClasses = (theme) => ({
  button: {
    margin: "0 10px 10px 0",
  },
  project: {
    "&:before": {
      backgroundColor: theme.palette.text.secondary,
    },
  },
  heading: {
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
  },
  skillButton: {
    textAlign: "left",
    marginRight: "10px",
    wordBreak: "break-word",
  },
  rating: {
    color: theme.palette.primary.main,
  },
  outerProgress: {
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.1)"
        : "rgba(0,0,0,0.1)",
  },
});
